import type { CatalogGroup } from "@/pages/catalog/catalogUtils";

interface CatalogIndexNavProps {
  groups: CatalogGroup[];
}

export default function CatalogIndexNav(_props: CatalogIndexNavProps) {
  return null;
}